<template>
  <div class="col-md-12 mx-auto">
    <v-row class="px-5 mt-5">
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.title" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="نام شخص/مجموعه"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete :items="workType" item-text="title" item-value="value" dense v-model="data.category"
                        prepend-inner-icon="mdi-pencil"
                        outlined clearable clear-icon="mdi-close-circle-outline"
                        label="حوزه فعالیت"></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.ig_id" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="ایدی اینستاگرام"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.mobile[0]" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="شماره همراه"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.ig_link" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="لینک بیو اینستاگرام"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.email" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="ایمیل"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.tg_id" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="ایدی تلگرام"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.phone[0]" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="شماره ثابت"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea rows="4" dense v-model="data.ig_bio" prepend-inner-icon="mdi-pencil" outlined clearable
                    clear-icon="mdi-close-circle-outline"
                    label="متن بیو اینستاگرام"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea rows="4" dense v-model="data.tg_bio" prepend-inner-icon="mdi-pencil" outlined clearable
                    clear-icon="mdi-close-circle-outline"
                    label="بیو تلگرام"></v-textarea>
      </v-col>
      <div class="col-md-12">
        <v-btn :loading="loading" @click="submit" class="submit-btn mr-auto float-left">
          <span class="fa fa-save ml-1" style="font-size: 14.5pt"></span>
          ثبت درخواست
        </v-btn>
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "submitForm",
  props: {
    value: {
      default: {
        title: '',
        category: '',
        mobile: [],
        phone: [],
        email: '',
        ig_id: '',
        ig_bio: '',
        ig_link: '',
        tg_id: '',
        tg_bio: '',
      }
    }
  },
  data() {
    return {
      loading: false,
      workType: [
        {title: 'لایف استایل ( سبک زندگی)', value: 'lifeStyle'},
        {title: 'موسیقی', value: 'music'},
        {title: 'املاک و خانه', value: 'real-estate'},
        {title: 'غذا (تستر و بلاگر غذا )', value: 'foodBlogger'},
        {title: 'اقتصادی و مالی', value: 'financial'},
        {title: 'سرمایه گذاری', value: 'investment'},
        {title: 'تکنولوژی', value: 'technology'},
        {title: 'طنز (واینر)', value: 'winer'},
        {title: 'بیوتی بلاگر', value: 'beautyBlogger'},
        {title: 'سفر و گردشگری', value: 'travelBlogger'},
        {title: 'ورزش و سلامت', value: 'sportBlogger'},
        {title: 'گیمینگ (استریمر)', value: 'gaming'},
        {title: 'مد و فشن', value: 'fashionBlogger'},
        {title: 'تناسب اندام (فیتنس بلاگر)', value: 'fitnessBlogger'},
        {title: 'ماشین', value: 'carBlogger'},
        {title: 'کتاب', value: 'bookBlogger'},
        {title: 'توسعه فردی', value: 'individualDevelopment'},
        {title: 'رشد', value: 'growth'},
        {title: 'راه‌های موفقیت', value: 'successWays'},
        {title: 'کوچ و کسب درآمد و بیزینسی', value: 'coach'},
        {title: 'بازاریابی (مارکتینگ)', value: 'marketing'},
        {title: 'آموزشی', value: 'education'},
      ]
    }
  },
  methods: {
    submit() {
      if (!this.value.title || !this.value.category) {
        this.$toast.error('نام مجموعه و حوزه فعالیت اجباری می باشند.');
        return false
      } else {

        this.loading = true;
        this.$api.post(`/business`, this.value).then((response) => {
          this.loading = false
          this.$toast.success('درخواست شما با موفقیت ثبت شد.');
          this.restsFn();
        }).catch((err) => {

          this.loading = false
          this.$toast.error('خطای سرور!');
        }).finally(() => {

          this.loading = false
        })
      }
    },
    restsFn() {
      this.value.title = '';
      this.value.category = '';
      this.value.mobile = [];
      this.value.phone = [];
      this.value.email = '';
      this.value.ig_id = '';
      this.value.ig_bio = '';
      this.value.ig_link = '';
      this.value.tg_id = '';
      this.value.tg_bio = '';
    }
  },
  computed: {
    data: {
      set(value) {
        return this.$emit('input', value);
      },
      get() {
        return this?.value;
      }
    }
  },
  mounted() {
    if (this.$route.name === 'submitForm') {
      this.restsFn();
    }
  }
}
</script>

<style scoped>

</style>